/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvitationChannelFromJSON, InvitationChannelToJSON, } from './InvitationChannel';
/**
 * Check if a given object implements the InvitationCreate interface.
 */
export function instanceOfInvitationCreate(value) {
    return true;
}
export function InvitationCreateFromJSON(json) {
    return InvitationCreateFromJSONTyped(json, false);
}
export function InvitationCreateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'channel': json['channel'] == null ? undefined : InvitationChannelFromJSON(json['channel']),
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
    };
}
export function InvitationCreateToJSON(json) {
    return InvitationCreateToJSONTyped(json, false);
}
export function InvitationCreateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'channel': InvitationChannelToJSON(value['channel']),
        'email': value['email'],
        'first_name': value['firstName'],
    };
}
